<template>
  <router-view />
</template>


<script>
import * as echarts from 'echarts'
import { provide } from 'vue'
export default {
  name: "App",
  components: {},
   setup(){
    provide('echarts',echarts)
  },
};
</script>

<style lang="scss">
@import "@/assets/style/default.scss";
</style>
